export class DiseaseModel {
  constructor(public name: string, public id: string) {}
}

export class DiseasesModel {
  constructor(public diseases: DiseaseModel[]) {}

  static fromJSON(json: DiseasesJSON | string): DiseasesModel {
    if (typeof json === 'string') {
      return JSON.parse(json, DiseasesModel.reviver);
    } else {
      const diseases = Object.create(DiseasesModel.prototype);
      return Object.assign(diseases, json);
    }
  }

  static reviver(key: string, value: any): any {
    return key === '' ? DiseasesModel.fromJSON(value) : value;
  }
}

export interface DiseasesJSON {
  diseases: DiseaseModel[];
}
